"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hydrogenPricingAndAnalytics = void 0;
const hydrogenPricingAndAnalytics = exports.hydrogenPricingAndAnalytics = {
  HYDROGEN_PRICING_AND_ANALYTICS: {
    en: {
      title: 'Hydrogen pricing and analytics',
      subtitle: 'Understand the nascent hydrogen market with expert intelligence',
      description: 'Stay ahead in this rapidly evolving market with transparent pricing, news, and analysis of changing policy and regulation.',
      list: ['Unrivalled interactive analytics', 'Daily, weekly and quarterly market analysis', 'Insight on current and future price trends', 'Direct access to ICIS energy analysts to discuss market assumptions and methodology.']
    },
    zh: {
      title: '氢能源价格和分析',
      subtitle: '专业资讯助您了解新兴的氢能源市场',
      description: '获取透明的价格、行业资讯、政策和法规变化的相关分析，在这一快速发展的市场上保持领先地位。',
      list: ['独一无二的交互式分析工具', '日度、周度、季度市场分析', '当前和未来价格趋势的洞察分析', '与ICIS能源分析师直接交流，探讨市场预测与方法论']
    }
  }
};